import { updateAndClearMaritalAnswers } from "../../../actions/userData";
import { getMaritalStatus } from "../../../calculations/userDataTransformer";


export const maritalStatusChangeHandler = (newAnswer, answers, setAllAnswers, startConfirmModal) => {
    let willNuke = checkIfWillNukePreviousAnswers(getMaritalStatus(answers), newAnswer, answers);
    if (willNuke) {
        startConfirmModal('This will wipe out some of your answers you\'ve supplied that are specific to your previous marital status.', updateAndClearMaritalAnswers);
    } else {
        let newAnswers = { ...answers };
        newAnswers['maritalStatus'] = newAnswer;
        setAllAnswers(newAnswers);
    }
}

function checkIfWillNukePreviousAnswers(prevAnswer, newAnswer, answers) {
    if (prevAnswer === 'married') {
        for (let key of Object.keys(answers)) {
            if (key.startsWith('spouse')) {
                return true;
            }
        }
    }
    return false;
}

export const updateMaritalAnswerAndClearOldAnswers = (newAnswer, answers) => {
    let newAnswers = { ...answers };
    let prevAnswer = getMaritalStatus(answers);
    newAnswers['maritalStatus'] = newAnswer;

    if (prevAnswer === 'married') {
        for (let key of Object.keys(answers)) {
            if (key.startsWith('spouse')) {
                delete newAnswers[key];
            }
        }
    }
    return newAnswers;
}